const convertDate = (date?: number): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date).toISOString().split("T")[0];
};
const convertDateBrComHora = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleString("en-GB");
};

function convertDateBrStringComHora(date?: string): string {
  if (date == undefined) {
    return "";
  }

  const [data, hora] = date.split(" ");
  return `${data} às ${hora}`;
}

const convertDateBr = (date?: number) => {
  if (date == undefined) {
    return "";
  }

  const myDate = new Date(date * 1000);
  return (
    myDate.getUTCDate() +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
  // return new Date(date * 1000).toLocaleDateString("en-GB");
};

const convertDateUs = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleDateString();
};

const convertStringDateToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const convertTimeStampToDate = (timestamp?: number) => {
  if (timestamp == undefined) {
    return "";
  }
  const data = new Date(timestamp * 1000);
  return data.toISOString().split("T")[0];
};

const convertTimeStampToDateBr = (timestamp?: number): string => {
  if (timestamp === undefined) {
    return "";
  }

  const data = new Date(timestamp * 1000);
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();

  return `${dia}/${mes}/${ano}`;
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};
export {
  convertDate,
  convertDateIso,
  convertDateBr,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
  convertDateBrComHora,
  convertDateBrStringComHora,
  convertTimeStampToDate,
  convertTimeStampToDateBr,
};
